const authConfig = {
  loginEndpoint: `${process.env.REACT_APP_SERVER_HOST}/admin/login`,
  logoutEndpoint: `${process.env.REACT_APP_SERVER_HOST}/admin/logout`,
  registerEndpoint: `${process.env.REACT_APP_SERVER_HOST}/admin/signup`,
  authEndpoint: `${process.env.REACT_APP_SERVER_HOST}/auth`,
};

export default authConfig;
